import {
  SearchState,
  SearchActionTypes,
  CLEAR_COUNT,
  CLEAR_SUGGESTIONS,
  SET_COUNT,
  SET_SUGGESTIONS,
  START_SEARCH_LOADING,
  FINISH_SEARCH_LOADING,
  SET_BLOCKED,
  SET_SEARCH_VALUE,
} from './types';

const initialState: SearchState = {
  suggestions: [],
  moreCount: 0,
  isLoading: false,
  isBlocked: false,
  searchValue: '',
};

export function searchReducer(
  state: SearchState = initialState,
  action: SearchActionTypes
): SearchState {
  switch (action.type) {
    case CLEAR_COUNT:
      return {
        ...state,
        moreCount: 0,
      };
    case CLEAR_SUGGESTIONS:
      return {
        ...state,
        suggestions: [],
      };
    case SET_COUNT:
      return {
        ...state,
        moreCount: action.payload,
      };
    case SET_SUGGESTIONS:
      return {
        ...state,
        suggestions: action.suggestions,
      };
    case START_SEARCH_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case FINISH_SEARCH_LOADING:
      return {
        ...state,
        isLoading: false,
      };
    case SET_BLOCKED:
      return {
        ...state,
        isBlocked: action.isBlocked,
      };
    case SET_SEARCH_VALUE:
      return {
        ...state,
        searchValue: action.value,
      };
    default:
      return state;
  }
}
